<template>
    <div>
        <!-- 实名认证 -->
        <div v-if="login_idcard == 0 || login_idcard == false">
            <div class="fxn-idcard" v-if="idcard_status == 0 || idcard_status == false || idcard_status == 1 || idcard_status == 3">
                <div class="fxn-idcard-wrap el-dialog__wrapper">
                    <div class="el-dialog__header">
                        <span class="el-dialog__title">提示</span>
                    </div>
                    <div class="el-dialog__body">
                        <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 0 || idcard_status == false">为加强合规作业管理、贯彻合法合规催收精神，首次注册登录用户者请进行实名认证，感谢配合！</div>
                        <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-else-if="idcard_status == 1">实名认证审核中，请稍等...</div>
                        <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-else-if="idcard_status == 3">您的实名认证信息审核不通过，请重新认证。</div>
                    </div>
                    <div class="el-dialog__footer">
                        <div class="dialog-footer">
                            <el-button @click="ColseLogin">关 闭</el-button>
                            <el-button v-show="idcard_status == 0 || idcard_status == 1 || idcard_status == 3 || idcard_status == false" type="primary" @click="toWorkOrder">去认证</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 实名认证 End -->
    </div>
</template>

<script>
    let ws = '';
    export default {
        data(){
            return{
                //实名认证
                login_idcard: '',
                idcard_status: '',
            }
        },
        methods:{
            //关闭实名认证并退出系统
            ColseLogin(){
                localStorage.clear();
                sessionStorage.clear();
                location.href = '/Login'
            },

            //去处理/去认证
            toWorkOrder(){
                this.$router.push({ path: '/realName' });                
            },

        },
        mounted(){

           let user = JSON.parse(localStorage.getItem('user'));
			if (user) {
                this.login_idcard = user.memberInfo.login_idcard;
                this.idcard_status = user.memberInfo.idcard_status;
            }
        }
    }
</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/User.vue